import api from "../Service";
import { toastr } from "react-redux-toastr";

const baseController = "api/admin/dashboard/report/book-performance";

const errorMessage = (error) =>
  error.response?.data?.message || error.message || "Please try again";

const request = async (path = "", params = {}) => {
  if (!navigator.onLine) throw new Error("No Internet Connection");
  try {
    const response = await api.get(`${baseController}${path}`, { params });
    if (response.data?.status === false) throw new Error(response.data.message || "Request failed");
    return response.data?.data ?? response.data;
  } catch (error) {
    toastr.error("Book Performance", errorMessage(error));
    throw error;
  }
};

const filenameFromHeader = (header, fallback) => {
  const match = header?.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)/i);
  return match ? decodeURIComponent(match[1]) : fallback;
};

const download = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

export const getBookPerformancePublishers = () => request("/publishers");
export const getBookPerformance = (params) => request("", params);
export const getBookPerformanceTrend = (params) => request("/trend", params);
export const getBookPerformanceDetail = ({ id, ...params }) => request(`/book/${id}`, params);
export const getBookPerformanceAuthors = ({ search = "" } = {}) =>
  request("/authors", search ? { search } : {});
export const getAuthorBookPerformance = ({ id, ...params }) => request(`/author/${id}`, params);
export const getAuthorBookPerformanceTrend = ({ id, ...params }) =>
  request(`/author/${id}/trend`, params);

export const downloadBookPerformanceCsv = async ({ section = "month", id, params, filename }) => {
  if (!navigator.onLine) throw new Error("No Internet Connection");
  const path =
    section === "trend"
      ? "/trend"
      : section === "book"
      ? `/book/${id}`
      : section === "authorMonth"
      ? `/author/${id}`
      : section === "authorTrend"
      ? `/author/${id}/trend`
      : "";
  try {
    const response = await api.get(`${baseController}${path}`, {
      params: { ...params, format: "csv" },
      responseType: "blob",
    });
    download(response.data, filenameFromHeader(response.headers["content-disposition"], filename));
    return true;
  } catch (error) {
    toastr.error("Book Performance", errorMessage(error));
    throw error;
  }
};
